module.exports = __webpack_public_path__ + "static/media/logo.6ea82d3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 24
// module chunks = 0